import { Component } from '@angular/core';
import { AuthService } from '../../services/auth/auth.service';
import { Router } from '@angular/router';
import { map, Subject } from 'rxjs';

@Component({
  selector: 'app-sso',
  templateUrl: './sso.component.html',
  styleUrl: './sso.component.css'
})
export class SsoComponent {
  private readonly _onDestroy$ = new Subject<void>();

  constructor(
    private authService: AuthService,
    private router: Router){

  }

  ngOnInit() {
    this.authService.handleSSORedirect().pipe(
      map(path => {
        if (path === '/login') {
          this.authService.login();
        } else if (path !== '') {
          this.router.navigate([path]);
        }
      })
    ).subscribe();
  }


  ngOnDestroy(): void {
    this._onDestroy$.next(undefined);
    this._onDestroy$.complete();
  }
}
